module.exports = __webpack_public_path__ + "img/593-347492.png";